/**
 * WordPress dependencies.
 */
import { __experimentalFontFamilyControl as FontFamilyControl } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';

/**
 * Exteranl dependencies.
 */
import { has, isEmpty, find } from 'lodash';

const GutenifyFontFamilyControl = ( {
	value = '',
	onChange,
	fontFamilies,
	...props
} ) => {
	// const globalStyle = useSelect( ( select ) => {
	// 	return select( coreStore ).__experimentalGetCurrentThemeBaseGlobalStyles();
	// }, [] );

	let blockLevelFontFamilies = [];

	// if ( has( globalStyle, `settings.typography.fontFamilies.theme` ) ) {
	// 	blockLevelFontFamilies = globalStyle.settings.typography.fontFamilies.theme;
	// }

	blockLevelFontFamilies = [ ...blockLevelFontFamilies, ...window._gutenify.font_families ];

	const getTypographySlug = ( fontFamilySlug ) => {
		let name = fontFamilySlug;
		const presetFont = blockLevelFontFamilies.filter( ( themeFont ) => themeFont.slug === fontFamilySlug );
		if ( ! isEmpty( presetFont ) ) {
			name = presetFont[ 0 ].fontFamily;
		}

		return name;
	};

	if ( ! fontFamilies ) {
		fontFamilies = blockLevelFontFamilies;
	}

	const val = getTypographySlug( value );

	return <FontFamilyControl
		value={ val }
		fontFamilies={ fontFamilies }
		onChange={ ( newValue ) => {
			const predefinedFontFamily = find(
				fontFamilies,
				( { fontFamily: f } ) => f === newValue
			);
			onChange( predefinedFontFamily ? predefinedFontFamily.slug : '' );
		} }
		{ ...props }
	/>;
};

export default GutenifyFontFamilyControl;
